import { render } from "./searchGoods.vue?vue&type=template&id=4a511f9a&scoped=true"
import script from "./searchGoods.vue?vue&type=script&lang=js"
export * from "./searchGoods.vue?vue&type=script&lang=js"

import "./searchGoods.vue?vue&type=style&index=0&id=4a511f9a&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a511f9a"]])

export default __exports__